/**
 * DataLayer GTM — Ville de La Sarre
 */

window.dataLayer = window.dataLayer || [];
window.vtxPoiTypedTerm = window.vtxPoiTypedTerm || '';

/**
 * Sanitize text value
 *
 * @param {string} value - Text value to sanitize
 * @return {string|undefined} Sanitized text or undefined
 */
function sanitizeText(value) {
  if (!value || typeof value !== 'string') return undefined;
  const clean = value.trim().toLowerCase();
  return clean.length > 0 ? clean : undefined;
}

/**
 * Extracts information from an <a> element for link_url, link_text, link_domain
 *
 * @param {HTMLAnchorElement} el - The anchor element to extract data from
 * @return {Object} An object containing link_url, link_text, and link_domain
 */
function getLinkData(el) {
  const href = el && el.href ? el.href : undefined;
  const text = el && el.innerText ? el.innerText.trim() : undefined;

  let domain;
  if (href) {
    try {
      domain = new URL(href).hostname;
    } catch (err) {
      domain = undefined;
    }
  }

  return {
    link_url: href || undefined,
    link_text: text || undefined,
    link_domain: domain || undefined,
  };
}

/**
 * Get selected event category from FacetWP events_categories radio facet
 */
function getEventCategory() {
  if (
    typeof FWP !== 'undefined' &&
    window.FWP &&
    window.FWP.facets &&
    window.FWP.facets.events_categories &&
    window.FWP.facets.events_categories.length > 0
  ) {
    return window.FWP.facets.events_categories[0];
  }

  const selectedRadio = document.querySelector(
    '.facetwp-facet[data-name="events_categories"] input[type="radio"]:checked, ' +
      '[data-facet="events_categories"] input[type="radio"]:checked'
  );

  if (selectedRadio) {
    const label =
      selectedRadio.closest('.facetwp-radio')?.textContent?.trim() ||
      selectedRadio.nextElementSibling?.textContent?.trim() ||
      selectedRadio.value;
    return sanitizeText(label);
  }

  return undefined;
}

/**
 * Get current weather temperature category
 */
function getWeatherTemperature() {
  let temp = null;

  if (window.dataLayer && window.dataLayer.length > 0) {
    const initialData = window.dataLayer[0];
    if (
      initialData.weather_temperature &&
      initialData.weather_temperature !== 'undefined'
    ) {
      temp = parseFloat(initialData.weather_temperature);
    }
  }

  if (temp === null) {
    const weatherWidget = document.querySelector('#weather_widget .temp');
    if (weatherWidget && weatherWidget.textContent) {
      const tempMatch = weatherWidget.textContent.trim().match(/-?\d+(\.\d+)?/);
      if (tempMatch) temp = parseFloat(tempMatch[0]);
    }
  }

  if (temp === null || isNaN(temp)) return undefined;
  if (temp <= 5) return 'cold';
  if (temp >= 25) return 'hot';
  return 'warm';
}

/* ============================================================
   start_form_submission
   ============================================================ */
(function () {
  const firedForms = {};

  document.addEventListener(
    'focusin',
    function (e) {
      const field = e.target.closest(
        '.gfield input, .gfield textarea, .gfield select'
      );
      if (!field) return;

      const form = field.closest('form[id^="gform_"]');
      if (!form) return;

      const formId = form.id.replace('gform_', '');
      if (firedForms[formId]) return;
      firedForms[formId] = true;

      const formMeta = window.vtxFormMeta?.[formId] ?? {};

      window.dataLayer.push({
        event: 'start_form_submission',
        form_name: formMeta.form_name || undefined,
        form_id: formId,
        form_category: formMeta.form_category || undefined,
      });
    },
    true
  );
})();

/* ============================================================
   form_submission — GF AJAX confirmation
   ============================================================ */
document.addEventListener('gform_confirmation_loaded', function (e) {
  const data = window.vtxLastFormSubmission || {};
  const formId = e.detail?.formId
    ? String(e.detail.formId)
    : data.form_id || undefined;

  window.dataLayer.push({
    event: 'form_submission',
    form_name: data.form_name || undefined,
    form_id: formId,
    form_category: data.form_category || undefined,
  });

  window.vtxLastFormSubmission = undefined;
});

/* ============================================================
   form_submission — Fallback page reload (ACF / GF redirect)
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  if (!window.vtxLastFormSubmission) return;

  const data = window.vtxLastFormSubmission;
  window.dataLayer.push({
    event: 'form_submission',
    form_name: data.form_name || undefined,
    form_id: data.form_id || undefined,
    form_category: data.form_category || undefined,
  });

  window.vtxLastFormSubmission = undefined;
});

/* ============================================================
   Courriel
   ============================================================ */
document.addEventListener('click', function (e) {
  const target = e.target.closest('a[href^="mailto:"]');
  if (!target) return;

  const link = getLinkData(target);
  window.dataLayer.push({
    event: 'Courriel',
    link_url: target.href,
    link_text: link.link_text || undefined,
    link_domain: link.link_domain || undefined,
  });
});

/* ============================================================
   Appel
   ============================================================ */
document.addEventListener('click', function (e) {
  const target = e.target.closest('a[href^="tel:"]');
  if (!target) return;

  const link = getLinkData(target);
  window.dataLayer.push({
    event: 'Appel',
    link_url: target.href,
    link_text: link.link_text || undefined,
    link_domain: link.link_domain || undefined,
  });
});

/* ============================================================
   search — findstr (recherche_rapide)
   Déclenché uniquement au lancement de la recherche (Enter / submit)
   ============================================================ */
(function () {
  const lastSearch = { term: null, time: 0 };

  function getSearchType(inputEl) {
    if (!inputEl) return undefined;
    if (
      inputEl.id === 'findstr_main_search_input' ||
      inputEl.id === 'findstr_main_search_input_bar' ||
      inputEl.id === 'findstr_main_search_input_result'
    )
      return 'recherche_rapide';
    return undefined;
  }

  function pushSearch(inputEl) {
    const searchTerm = inputEl?.value
      ? inputEl.value.trim().toLowerCase()
      : undefined;
    if (!searchTerm) return;

    const now = Date.now();
    if (searchTerm === lastSearch.term && now - lastSearch.time < 500) return;

    lastSearch.term = searchTerm;
    lastSearch.time = now;

    window.dataLayer.push({
      event: 'search',
      search_term: searchTerm,
      search_category: getEventCategory(),
      search_type: getSearchType(inputEl),
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // A) Touche Entrée
    const inputs = [
      document.getElementById('findstr_main_search_input'),
      document.getElementById('findstr_main_search_input_bar'),
    ].filter(Boolean);

    inputs.forEach(function (inputEl) {
      inputEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') pushSearch(inputEl);
      });
    });

    // B) Bouton submit
    document
      .querySelectorAll(
        '#search-modal button[type="submit"],' +
          '.search-window button[type="submit"],' +
          'form.findstr-form button[type="submit"],' +
          '.search-modal__submit'
      )
      .forEach(function (btn) {
        btn.addEventListener('click', function () {
          const form = btn.closest('form');
          const inputEl = form
            ? form.querySelector('input[type="search"], input[type="text"]')
            : inputs[0];
          if (inputEl) pushSearch(inputEl);
        });
      });

    // C) Page de résultats — une seule fois au chargement
    const resultInput = document.getElementById(
      'findstr_main_search_input_result'
    );
    if (resultInput?.value?.trim().length > 0) {
      pushSearch(resultInput);
    }
  });
})();

/* ============================================================
   search — carte interactive (poi_search FacetWP)
   Déclenché indépendamment de findstr
   ============================================================ */
/* ============================================================
   search — carte interactive (poi_search FacetWP)
   Déclenché par le bouton "Go" (.facetwp-autocomplete-update)
   ou la touche Entrée dans l'input
   ============================================================ */
/* ============================================================
   search — carte interactive (poi_search FacetWP)
   FacetWP recrée l'input après chaque recherche
   → rebind après chaque facetwp-loaded
   ============================================================ */
(function () {
  const lastPoiSearch = { term: null, time: 0 };

  function pushPoiSearch(term) {
    if (!term || term.trim().length === 0) return;

    const cleanTerm = term.trim().toLowerCase();
    const now = Date.now();

    if (cleanTerm === lastPoiSearch.term && now - lastPoiSearch.time < 500)
      return;

    lastPoiSearch.term = cleanTerm;
    lastPoiSearch.time = now;

    window.dataLayer.push({
      event: 'search',
      search_term: cleanTerm,
      search_category: undefined,
      search_type: 'carte_interactive',
    });
  }

  function bindPoiEvents() {
    const poiInput = document.querySelector(
      '.facetwp-facet[data-name="poi_search"] input.facetwp-autocomplete'
    );

    if (!poiInput || poiInput._vtxBound) return;
    const goBtn = document.querySelector('.facetwp-autocomplete-update');
    poiInput._vtxBound = true;

    poiInput.addEventListener('input', function () {
      window.vtxPoiTypedTerm = poiInput.value
        ? poiInput.value.trim().toLowerCase()
        : '';
    });

    // A) Bouton "Go"
    if (goBtn && !goBtn._vtxBound) {
      goBtn._vtxBound = true;
      goBtn.addEventListener('click', function () {
        pushPoiSearch(poiInput.value);
      });
    }

    // B) Touche Entrée
    poiInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') pushPoiSearch(poiInput.value);
    });
  }

  // C) Clic sur une suggestion autocomplete — délégation sur document
  //    Déclenche search_clicks
  //    Une seule fois car document ne change jamais
  (function bindFcompleteOnce() {
    document.addEventListener('mousedown', function (e) {
      const suggestion = e.target.closest(
        '.facetwp-facet[data-name="poi_search"] .fcomplete-result'
      );
      if (!suggestion) return;

      const suggestionText =
        suggestion.getAttribute('data-value') || suggestion.textContent?.trim();
      if (!suggestionText) return;

      const typedTerm = window.vtxPoiTypedTerm
        ? window.vtxPoiTypedTerm.trim().toLowerCase()
        : '';

      const cleanTerm = suggestionText.trim().toLowerCase();
      const searchTerm = typedTerm || cleanTerm || undefined;

      const linkEl =
        suggestion.closest('a[href]') || suggestion.querySelector('a[href]');
      const linkUrl = linkEl?.href || undefined;
      let linkDomain;
      if (linkUrl) {
        try {
          linkDomain = new URL(linkUrl).hostname;
        } catch (err) {
          linkDomain = undefined;
        }
      }

      window.dataLayer.push({
        event: 'search_clicks',
        search_term: searchTerm,
        search_category: undefined,
        link_url: linkUrl,
        link_text: cleanTerm,
        link_domain: linkDomain,
        search_type: 'carte_interactive',
      });
    });
  })();

  // Rebind après chaque rendu FacetWP (facetwp-loaded recrée les éléments DOM)
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('facetwp-loaded', function () {
      bindPoiEvents();
    });
  }

  // Fallback MutationObserver si jQuery/FacetWP pas encore prêt
  const observer = new MutationObserver(function () {
    const poiInput = document.querySelector(
      '.facetwp-facet[data-name="poi_search"] input.facetwp-autocomplete'
    );
    if (poiInput && !poiInput._vtxBound) {
      bindPoiEvents();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    bindPoiEvents(); // Tentative initiale

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();

/* ============================================================
   search_clicks — clic sur un marqueur de la carte interactive
   Utilise le hook natif FacetWP VTX Map
   ============================================================ */
(function () {
  let mapMarkerBound = false;

  function bindMapMarkerClick() {
    if (mapMarkerBound) return;

    if (
      typeof window.FWP === 'undefined' ||
      !window.FWP.hooks ||
      typeof window.FWP.hooks.addAction !== 'function'
    )
      return;

    window.FWP.hooks.addAction(
      'facetwp_vtx_map/marker/click',
      function (marker) {
        const postdata = marker?.postdata;
        if (!postdata) return;

        const poiInput = document.querySelector(
          '.facetwp-facet[data-name="poi_search"] input.facetwp-autocomplete'
        );
        const typedTerm = window.vtxPoiTypedTerm
          ? window.vtxPoiTypedTerm.trim().toLowerCase()
          : '';

        const inputValue = poiInput?.value
          ? poiInput.value.trim().toLowerCase()
          : '';

        const searchTerm = typedTerm || inputValue || undefined;

        const linkUrl = postdata.permalink || undefined;
        const linkText = postdata.title
          ? postdata.title.trim().toLowerCase()
          : undefined;

        let linkDomain;
        if (linkUrl) {
          try {
            linkDomain = new URL(linkUrl).hostname;
          } catch (err) {
            linkDomain = undefined;
          }
        }

        window.dataLayer.push({
          event: 'search_clicks',
          search_term: searchTerm,
          search_category: undefined,
          link_url: linkUrl,
          link_text: linkText,
          link_domain: linkDomain,
          search_type: 'carte_interactive',
        });
      }
    );

    mapMarkerBound = true; // ✅ ICI — après addAction, pas dans le callback
  }

  if (typeof jQuery !== 'undefined') {
    jQuery(document).one('facetwp-loaded', function () {
      bindMapMarkerClick();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindMapMarkerClick();
  });
})();

/* ============================================================
   search_clicks — résultats findstr
   ============================================================ */
document.addEventListener('click', function (e) {
  const resultLink = e.target.closest(
    '.findstr-result a, .findstr-results a, .findstr-item a, [data-findstr-result] a'
  );
  if (!resultLink) return;

  const searchInput =
    document.getElementById('findstr_main_search_input_result') ||
    document.getElementById('findstr_main_search_input') ||
    document.getElementById('findstr_main_search_input_bar');

  const searchTerm = searchInput?.value
    ? searchInput.value.trim().toLowerCase()
    : undefined;
  const link = getLinkData(resultLink);

  window.dataLayer.push({
    event: 'search_clicks',
    search_term: searchTerm,
    search_category: getEventCategory(),
    link_url: link.link_url,
    link_text: link.link_text,
    link_domain: link.link_domain,
    search_type: 'recherche_rapide',
  });
});

/* ============================================================
   search_clicks — clic sur un événement (calendrier FacetWP)
   ============================================================ */
/* ============================================================
   search_clicks — clic sur un événement (calendrier FacetWP)
   ============================================================ */
document.addEventListener('click', function (e) {
  const eventLink = e.target.closest(
    'article.event-item a.event-item__container'
  );
  if (!eventLink) return;

  const titleEl = eventLink.querySelector('.event-item__title');
  const linkText = titleEl ? titleEl.innerText.trim().toLowerCase() : undefined;

  const categories = [];
  eventLink.querySelectorAll('.event-item__category').forEach(function (el) {
    const cat = el.innerText.trim().toLowerCase();
    if (cat) categories.push(cat);
  });
  const searchCategory =
    categories.length > 0 ? categories.join(',') : undefined;

  const link = getLinkData(eventLink);

  window.dataLayer.push({
    event: 'search_clicks',
    search_term: undefined,
    search_category: searchCategory,
    link_url: link.link_url,
    link_text: linkText,
    link_domain: link.link_domain,
    search_type: 'calendrier_activites',
  });
});

/* ============================================================
   search_clicks — changement de catégorie (radio FacetWP)
   ============================================================ */
document.addEventListener('change', function (e) {
  const categoryRadio = e.target.closest(
    '.facetwp-facet[data-name="events_categories"] input[type="radio"],' +
      '[data-facet="events_categories"] input[type="radio"]'
  );
  if (!categoryRadio?.checked) return;

  const searchInput =
    document.getElementById('findstr_main_search_input_result') ||
    document.getElementById('findstr_main_search_input') ||
    document.getElementById('findstr_main_search_input_bar');

  const searchTerm = searchInput?.value
    ? searchInput.value.trim().toLowerCase()
    : undefined;

  const categoryLabel =
    categoryRadio.closest('.facetwp-radio')?.textContent?.trim() ||
    categoryRadio.nextElementSibling?.textContent?.trim() ||
    categoryRadio.value;

  window.dataLayer.push({
    event: 'search_clicks',
    search_term: searchTerm,
    search_category: sanitizeText(categoryLabel),
    link_url: undefined,
    link_text: categoryLabel,
    link_domain: undefined,
    search_type: 'calendrier_activites',
  });
});

/* ============================================================
   banner_clicks
   ============================================================ */
document.addEventListener('click', function (e) {
  const banner = e.target.closest('.alert-message');
  if (!banner) return;

  const closeBtn = e.target.closest(
    '.alert-message__close, [data-close], .close-btn'
  );
  if (closeBtn) {
    window.dataLayer.push({
      event: 'banner_clicks',
      click_type: 'close',
      link_url: undefined,
      link_text: undefined,
      link_domain: undefined,
    });
    return;
  }

  const linkEl = e.target.closest('a');
  if (!linkEl) return;

  const href = linkEl.getAttribute('href') || '';
  if (href.startsWith('mailto:') || href.startsWith('tel:')) return;

  const link = getLinkData(linkEl);
  window.dataLayer.push({
    event: 'banner_clicks',
    click_type: 'link',
    link_url: link.link_url,
    link_text: link.link_text,
    link_domain: link.link_domain,
  });
});

/* ============================================================
   cta_clicks (cold / warm / hot)
   ============================================================ */
document.addEventListener('click', function (e) {
  let cta = e.target.closest(
    'a[data-cta-temperature], button[data-cta-temperature]'
  );

  if (!cta) {
    const linkEl = e.target.closest('a[href]');
    if (!linkEl) return;

    const ctaContexts = [
      '.btn',
      '.button',
      '.cta',
      '[class*="call-to-action"]',
      '[class*="action"]',
      '.hero a',
      '.banner a',
      '.promo a',
      '.highlight a',
    ];

    const isCtaContext = ctaContexts.some(
      (selector) => linkEl.matches(selector) || linkEl.closest(selector)
    );

    if (!isCtaContext) {
      const parentWithTemp = linkEl.closest('[data-cta-temperature]');
      if (!parentWithTemp) return;
      cta = linkEl;
      cta._ctaTemperature = parentWithTemp.getAttribute('data-cta-temperature');
    } else {
      cta = linkEl;
    }
  }

  const href = cta.getAttribute('href') || '';
  if (href.startsWith('mailto:') || href.startsWith('tel:')) return;

  const temperature =
    cta._ctaTemperature ||
    cta.getAttribute('data-cta-temperature') ||
    getWeatherTemperature() ||
    undefined;

  let location = 'middle';
  if (cta.closest('.site-header, .navbar')) location = 'header';
  else if (cta.closest('.site-footer')) location = 'footer';
  else if (cta.closest('.hero, .page-header, [class*="top"]')) location = 'top';
  else if (cta.closest('[class*="bottom"]')) location = 'bottom';

  const link = getLinkData(cta);

  window.dataLayer.push({
    event: 'cta_clicks',
    cta: {
      temperature,
      location,
      link_url: link.link_url,
      link_text: link.link_text,
      link_domain: link.link_domain,
    },
    user_id: undefined,
  });
});

/* ============================================================
   maps_clicks
   ============================================================ */
document.addEventListener('click', function (e) {
  const linkEl = e.target.closest('a[href]');
  if (!linkEl) return;

  try {
    const domain = new URL(linkEl.href).hostname;
    const isGoogleMaps =
      domain.includes('google.com') && linkEl.href.includes('maps');
    const isInMapContainer = !!linkEl.closest(
      '.interactive-map, .vtx-map, [class*="map"]'
    );

    if (!isGoogleMaps && !(isInMapContainer && domain.includes('google')))
      return;
  } catch (err) {
    return;
  }

  const link = getLinkData(linkEl);
  window.dataLayer.push({
    event: 'maps_clicks',
    link_url: link.link_url,
    link_text: link.link_text,
    link_domain: link.link_domain,
  });
});
